import "./Newsletter.css";
export function Newsletter(){
    return(
        <div className="newsletter-section">
            <div className="newsletter-content">
                <span className="small-text">Newsletter</span>
                <span className="big-text">Sign up for latest update and offers</span>
                <div className="form">
                    <input className="form-control" type="email" placeholder="Email Address" />
                    <button className="btn btn-outline-info">Subscribe</button>
                </div>
                <div className="text">
                    Will be used in accordance with our privacy policy
                </div>
                <div className="social-icons d-flex">
                    <div className="icon">
                    <span className="bi bi-facebook"></span>
                    </div>
                    <div className="icon">
                    <span className="bi bi-twitter"></span>
                    </div>
                    <div className="icon">
                    <span className="bi bi-instagram"></span>
                    </div>
                    <div className="icon">
                    <span className="bi bi-linkedin"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}